import bscIcon from '../assets/images/bsc.svg';
import busdIcon from '../assets/images/busd.png';
import daiIcon from '../assets/images/DAI.png';
import ethIcon from '../assets/images/eth.png';
import maticIcon from '../assets/images/matic.png';
import tusdIcon from '../assets/images/TUSD.png';
import usdcIcon from '../assets/images/usdc.svg';
import usdtIcon from '../assets/images/usdt-token.svg';

export const TOKEN_LIST: Record<string, {symbol: string; icon: string}> = {
  bsc: {
    symbol: 'BSC',
    icon: bscIcon,
  },
  matic: {
    symbol: 'MATIC',
    icon: maticIcon,
  },
  eth: {
    symbol: 'ETH',
    icon: ethIcon,
  },
  usdt: {
    symbol: 'USDT',
    icon: usdtIcon,
  },
  usdc: {
    symbol: 'USDC',
    icon: usdcIcon,
  },
  busd: {
    symbol: 'BUSD',
    icon: busdIcon,
  },
  tusd: {
    symbol: 'TUSD',
    icon: tusdIcon,
  },
  dai: {
    symbol: 'DAI',
    icon: daiIcon,
  },
  pjt: {
    symbol: 'USDT',
    icon: usdtIcon,
  },
  stb: {
    symbol: 'BUSD',
    icon: busdIcon,
  },
};
